export default "__VITE_ASSET__BxV8RIN4__"